module.exports = __webpack_public_path__ + "img/carousel3.0485740d.jpg";